// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { ArrowLeftOutlined, PhoneOutlined, WhatsAppOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflow: 'auto',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
// };

// const cardStyle = {
//   backgroundColor: 'rgb(230, 232, 233)',
//   borderRadius: '10px',
//   margin: '10px',
//   padding: '10px',
//   boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
// };

// const infoCardStyle = {
//   backgroundColor: 'rgb(217, 221, 224)',
//   borderRadius: '6px',
//   padding: '10px',
//   marginTop: '10px',
// };

// const headerStyle = {
//   backgroundColor: '#fff',
//   padding: '15px',
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   borderBottom: '1px solid #ddd',
// };

// const MultipleDgWeb = () => {
  // const [dgData, setDgData] = useState([]);
  // const dist = sessionStorage.getItem('dist') || '320E';
  // const navigate = useNavigate();

  // useEffect(() => {
  //   axios.get('https://lionsdirectoryapi.emedha.in/get/multiple/DG', {
  //     params: { dist },
  //   })
  //     .then(res => setDgData(res.data))
  //     .catch(err => console.error('Error fetching DG data:', err));
  // }, [dist]);

  // const openDial = (phone) => {
  //   window.location.href = `tel:${phone}`;
  // };

//   return (
//     <div style={previewContainerStyle}>
//       <div style={headerStyle}>
//                 <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>Multiple DG</h6>
//       </div>
//     </div>
//       </div>

//       <div style={{ overflowY: 'auto', padding: '10px' }}>
//         {dgData.map((item) => (
//           <div key={item.id} style={cardStyle}>
//             <div style={{ textAlign: 'center' }}>
            //   <img
            //     src={item.photo || '/default-profile.jpg'}
            //     alt="Profile"
            //     style={{ height: '100px', width: '100px', borderRadius: '50%', border: '2px solid #ccc' }}
            //   />
            // </div>
//             <div style={infoCardStyle}>
//               <p style={{ fontSize: '16px', fontWeight: 'bold', margin: '5px 0' }}>{item.name}</p>
//               <p style={{ fontSize: '15px', margin: '5px 0' }}>{item.position}</p>
//               <p style={{ fontSize: '15px', margin: '5px 0' }}>{item.email}</p>
//               <p style={{ fontSize: '15px', margin: '5px 0', color: '#297af5', cursor: 'pointer' }} onClick={() => openDial(item.mobile)}>
//                 <PhoneOutlined /> {item.mobile}
//               </p>
//             </div>
            // <div style={{ textAlign: 'center', marginTop: '10px' }}>
            //   <a
            //     href={`https://wa.me/91${item.mobile}?text=Hello`}
            //     target="_blank"
            //     rel="noopener noreferrer"
            //     style={{ fontSize: '20px', color: 'rgb(30, 176, 30)' }}
            //   >
            //     <WhatsAppOutlined />
            //   </a>
            // </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default MultipleDgWeb;


import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { ChevronLeft, Calendar, Phone, MessageCircle, PersonStandingIcon } from 'lucide-react';

const MultipleDgWeb = ({ onBack, styles }) => {


  const [dgData, setDgData] = useState([]);
  const dist = sessionStorage.getItem('dist')


  useEffect(() => {
    axios.get('https://lionsdirectoryapi.emedha.in/get/multiple/DG', {
      params: { dist },
    })
      .then(res => setDgData(res.data))
      .catch(err => console.error('Error fetching DG data:', err));
  }, [dist]);

  const openDial = (phone) => {
    window.location.href = `tel:${phone}`;
  };






  return (
    <div style={styles.scrollArea}>
      {/* Header */}
      <div style={{ backgroundColor: '#0033A0', color: 'white', padding: '15px' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
            <ChevronLeft onClick={onBack} style={{ cursor: 'pointer' }} size={24} />
            <h2 style={{ fontSize: '18px', margin: 0 }}>
              Multiple DG
            </h2>
          </div>
          <PersonStandingIcon size={20} />
        </div>

     
      </div>

      {/* List */}
      <div style={{ padding: '15px' }}>

        {dgData.map((item, index) => (
          <div key={index} style={{
            backgroundColor: 'white',
            borderRadius: '15px',
            padding: '15px',
            marginBottom: '15px',
            border: '1px solid #eee',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}>

            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>

              {/* Avatar */}
         <div style={{
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  overflow: 'hidden', // so image fits circle
  backgroundColor: '#E9ECEF',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontSize: '24px',
  fontWeight: 'bold',
  color: '#6C757D'
}}>
  {item.photo ? (
    <img 
      src={item.photo} 
      alt={item.name} 
      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
    />
  ) : (
      item.name?.charAt(0)
  )}
</div>

              {/* Info */}
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: 0, fontSize: '13px' }}>{item.name}</h3>
                <div style={{ fontSize: '16px', color: '#666' }}>
                  {item.position}
                </div>
                <div style={{ fontSize: '12px', color: '#999' }}>
                  Email: {item.email}
                </div>
              </div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: '8px', flexDirection:'column' }}>

                <a href={`tel:${item.mobile}`}>
                  <Phone size={18} color="#0033A0" />
                </a>
                  <div>
              <a
                href={`https://wa.me/91${item.mobile}?text=Hello`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ fontSize: '20px', color: 'rgb(30, 176, 30)' }}
              >
                 <MessageCircle size={18} color="#25D366" />
              </a>
            </div>
              </div>
            </div>

        

          </div>
        ))}

    

      </div>
    </div>
  );
};

export default MultipleDgWeb;